export const IndexLogsActionTypes = {
    RECEIVED_LOGS: 'RECEIVED_LOGS',
    FAILED_RECEIVING_LOGS: 'FAILED_RECEIVING_LOGS',
    SET_IS_FETCHING: 'SET_IS_FETCHING',
};
export function fetchIndexLogs_ac(params) {
    return (dispatch) => {
        dispatch(fetching(true));
        return window.sch.post('/api/alist/idx', { ...params })
            .then(result => {
                if (result.error) {
                    throw new Error(result.error)
                }
                dispatch({
                    type: IndexLogsActionTypes.RECEIVED_LOGS,
                    records: result.rows,
                    tags: result.tagCounts,
                    pagination: result.pagination
                });
            })
            .catch(error => {
                dispatch({
                    type: IndexLogsActionTypes.FAILED_RECEIVING_LOGS,
                    error
                });
            })
            .finally(() => {
                dispatch(fetching(false));
            });
    }
}

export const fetching = isFetching => ({
    type: IndexLogsActionTypes.SET_IS_FETCHING,
    isFetching
})